import React from 'react'

interface TaskStartIconProps {
  size?: number
  className?: string
}

export const TaskStartIcon: React.FC<TaskStartIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M5.33 1.33V4M10.67 1.33V4M2 6.67H14M5.33 9.33H5.34M8 9.33H8.01M10.67 9.33H10.67M5.33 12H5.34M8 12H8.01M10.67 12H10.67M3.33 2.67H12.67C13.4 2.67 14 3.26 14 4V13.33C14 14.07 13.4 14.67 12.67 14.67H3.33C2.6 14.67 2 14.07 2 13.33V4C2 3.26 2.6 2.67 3.33 2.67Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
